import { ComponentProps } from "react";
import * as S from "./styles";
interface InputCheckboxProps extends ComponentProps<"input"> {
  label?: string;
}

export const InputCheckbox = ({ label, ...rest }: InputCheckboxProps) => {
  return (
    <S.InputCheckboxLabel>
      {label && <span>{label}</span>}
      <S.InputCheckboxWrapper>
        <input {...rest} type="checkbox" />
      </S.InputCheckboxWrapper>
    </S.InputCheckboxLabel>
  );
};
